import React from "react"
import { Redirect, Route, Switch } from "react-router"
import Queries from "../modules/queries/queries"
import IsmagCriteria from "../modules/ismagquery/criteria/ismag-criteria"
import IsmagResults from "../modules/ismagquery/results/results"
import CcbCriteria from "../modules/ccb/criteria/ccb-criteria"
import CCBResults from "../modules/ccb/results/ccbresults"
import CcbDetail from "../modules/ccb/detail/ccbdetail"
import DepositoryCriteria from "../modules/depository/criteria/depository-criteria"
import DepositoryResults from "../modules/depository/results/depository-results"
import DepoDetail from "../modules/depository/detail/depository-detail"
import NoMatch from "./no-match"

  const routes = (
    <Switch>
        <Redirect exact from="/" to="/queries" />
        <Route path="/queries" exact >
            <Queries/>
        </Route>
        <Route path="/ismag" exact >
            <IsmagCriteria/>
        </Route>
        <Route path="/ismagresults" exact >
            <IsmagResults/>
        </Route>        
        <Route path="/ccb" exact >
           <CcbCriteria/>            
        </Route>
        <Route path="/ccbresults" exact >
            <CCBResults/> 
        </Route>        
        <Route path="/ccb/:acctno" component={CcbDetail} />
        {/*  depositories follow different schema, one page for criteria, one for results, one for detail, other pages have criteria and results merged*/}
        <Route path="/depocriteria" exact >
            <DepositoryCriteria/> 
        </Route>
        <Route path="/deporesults" exact >
            <DepositoryResults/> 
        </Route>
        <Route path="/depo/:depcode" component={DepoDetail} />
        {/* Securities follow the same schema as depositories. Side effects handled via sagas */}
        <Route path="/about">Hello from About R</Route>        
        <Route>
            <NoMatch/>
        </Route>
  </Switch>
  )

  export default routes